import { render, staticRenderFns } from "./waitingForDocsTable.vue?vue&type=template&id=3d36ce90"
import script from "./waitingForDocsTable.vue?vue&type=script&lang=js"
export * from "./waitingForDocsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports